import type { ReactNode } from 'react';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@repo/videa-components';

interface TooltipButtonProps {
  duration?: number;
  icon?: IconProp;
  tooltip: string;
  children?: ReactNode;
  disabled?: boolean;
  iconClassName?: string;
  tooltipDisabled?: boolean;
  [key: string]: any;
}

export const TooltipButton = ({
  duration = 100,
  icon,
  tooltip,
  children,
  disabled = false,
  iconClassName = '',
  tooltipDisabled = false,
  ...buttonProps
}: TooltipButtonProps) => {
  // Check if this is a spinner icon to apply animation
  const isSpinner =
    (typeof icon === 'object' &&
      'iconName' in icon &&
      icon.iconName === 'spinner') ||
    (typeof icon === 'object' &&
      'icon' in icon &&
      Array.isArray(icon.icon) &&
      icon.icon[1] === 'spinner');

  const buttonContent = (
    <Button disabled={disabled} {...buttonProps}>
      {icon && (
        <span>
          <FontAwesomeIcon
            icon={icon}
            className={`${isSpinner ? 'vai-animate-spin' : ''} ${iconClassName}`.trim()}
          />
        </span>
      )}
      {children}
    </Button>
  );

  return (
    <TooltipProvider delayDuration={duration}>
      <Tooltip>
        <TooltipTrigger asChild>
          {disabled ? (
            <span className="vai-inline-block vai-cursor-not-allowed">
              {buttonContent}
            </span>
          ) : (
            buttonContent
          )}
        </TooltipTrigger>
        {!tooltipDisabled && <TooltipContent>{tooltip}</TooltipContent>}
      </Tooltip>
    </TooltipProvider>
  );
};
